import React from "react";
import axios from "axios";
import Moment from "react-moment";
import PageTitle from "../../components/common/PageTitle";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
} from "shards-react";
import {
  EVENT_DISPLAY_NAMES,
  EVENT_TYPES,
  IMPACT_FEST_CATEGORIES_DISPLAY_NAMES,
  IMPACT_FEST_CATEGORIES,
} from "../../constants";

class CBPList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      currentPage: 1,
      totalPages: 1,
      isFetching: false,
    };
  }

  getCBPList = (page = 1) => {
    this.setState({ isFetching: true });

    axios
      .get(`${process.env.REACT_APP_API_URL}/cbp`, {
        params: { page, limit: 5 },
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        this.setState({
          data: res.data.CBPs,
          currentPage: res.data.currentPage,
          totalPages: res.data.totalPages,
          isFetching: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.setState({ isFetching: false });
      });
  };

  componentDidMount() {
    this.getCBPList();
  }

  handlePageChange = (page) => {
    this.getCBPList(page);
  };

  editCBP = (id) => {
    this.props.history.push(`/cbp-list-edit/${id}`);
  };

  deleteCBP = (id) => {
    if (!window.confirm("Are you sure?")) {
      return false;
    }

    axios
      .delete(`${process.env.REACT_APP_API_URL}/cbp/${id}`, {
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        if (res.status === 200) {
          this.getCBPList(this.state.currentPage);
        }
      });
  };
  tableConfig = {
    columns: [
      {
        key: "name",
        header: "Name",
        width: "10%",
      },
      {
        key: "updated_on",
        header: "Last Update",
        format: (date) => <Moment format="DD-MMMM-YYYY">{date}</Moment>,
      },
      {
        key: "term",
        header: "Event Held Month",
        format: (date) => <Moment format="MMMM-YYYY">{date}</Moment>,
      },
      {
        key: "description",
        header: "Description",
        width: "20%",
      },
      {
        key: "event_type",
        header: "Event Type",
        format: (type) => this.getEventDisplayName(type),
      },
      {
        key: "count",
        header: "Count",
      },
    ],
  };

  getEventDisplayName = (eventType) => {
    if (!eventType) {
      return "Boot-Camp Program";
    }
    const normalizedType = EVENT_TYPES[eventType] || eventType;
    return EVENT_DISPLAY_NAMES[normalizedType] || eventType;
  };

  getCategoryDisplayName = (category) => {
    if (!category || ["undefined", "null"].includes(category)) {
      return "-";
    }
    const normalizedType = IMPACT_FEST_CATEGORIES[category] || category;
    return IMPACT_FEST_CATEGORIES_DISPLAY_NAMES[normalizedType] || category;
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="main-content-container px-4">
          <Row noGutters className="page-header py-4">
            <PageTitle
              sm="4"
              title="Bootcamp Events"
              subtitle="Upload Bootcamp Trainee List"
              className="text-sm-left"
            />
            <div className="add-new">
              <Button
                className="add-new-btn"
                onClick={() => this.props.history.push("/cbp-list-upload")}
              >
                Upload List
              </Button>
            </div>
          </Row>
          <Row>
            <Col>
              <Card small className="mb-4">
                <CardHeader className="border-bottom"></CardHeader>
                <CardBody className="p-0 pb-3">
                  {this.state.data.length > 0 ? (
                    <>
                      <div className="table-responsive">
                        <table className="table mb-0" id="my-table">
                          <thead className="bg-light">
                            <tr>
                              {this.tableConfig.columns.map((column, idx) => (
                                <th
                                  key={idx}
                                  scope="col"
                                  className="border-0"
                                  style={
                                    column.width ? { width: column.width } : {}
                                  }
                                >
                                  {column.header}
                                </th>
                              ))}
                              <th scope="col" className="border-0">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.data.map((item, index) => (
                              <tr key={index}>
                                {this.tableConfig.columns.map(
                                  (column, colIdx) => {
                                    const value = item[column.key];
                                    return (
                                      <td key={colIdx}>
                                        {column.format
                                          ? column.format(value)
                                          : value}
                                      </td>
                                    );
                                  }
                                )}
                                <td>
                                  <div className="d-flex flex-column">
                                    <Button
                                      href={`/cbp-list-participant/${item._id}`}
                                      className="mb-2 btn"
                                      theme="primary"
                                      style={{ width: "70%" }}
                                    >
                                      View
                                    </Button>
                                    <Button
                                      onClick={() => this.editCBP(item._id)}
                                      className="mb-2 btn"
                                      theme="success"
                                      style={{ width: "70%" }}
                                    >
                                      Edit
                                    </Button>
                                    <Button
                                      onClick={() => this.deleteCBP(item._id)}
                                      className="mb-2 btn"
                                      theme="danger"
                                      style={{ width: "70%" }}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {this.state.totalPages > 1 && (
                        <Row className="d-flex justify-content-end">
                          <div className="pagination mt-3 mr-5">
                            <Button
                              outline
                              size="sm"
                              theme={
                                this.state.currentPage > 1
                                  ? "primary"
                                  : "secondary"
                              }
                              className="mb-2 mr-1"
                              disabled={this.state.currentPage <= 1}
                              onClick={() =>
                                this.handlePageChange(
                                  this.state.currentPage - 1
                                )
                              }
                            >
                              Previous
                            </Button>
                            <span className="mx-2">
                              Page {this.state.currentPage} of{" "}
                              {this.state.totalPages}
                            </span>
                            <Button
                              outline
                              size="sm"
                              theme={
                                this.state.currentPage < this.state.totalPages
                                  ? "primary"
                                  : "secondary"
                              }
                              className="mb-2 mr-1"
                              disabled={
                                this.state.currentPage >= this.state.totalPages
                              }
                              onClick={() =>
                                this.handlePageChange(
                                  this.state.currentPage + 1
                                )
                              }
                            >
                              Next
                            </Button>
                          </div>
                        </Row>
                      )}
                    </>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <h3>No Data Found</h3>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default CBPList;
